var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"main-content mb-5"},[_c('b-row',_vm._l((_vm.items),function(item){return _c('kayak-list-item',{key:item.id,attrs:{"item":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }